module.exports = __webpack_public_path__ + "static/media/bars.d6763eaf.svg";